/**
 * AgentLevelBadge — coloured pill showing an agent's competency level.
 *
 * L1=grey, L2=blue, L3=green, L4=orange, L5=purple
 * EPIC-12-05 AC: badge displays level code and localised label.
 */

import { useTranslation } from 'react-i18next';
import type { AgentLevel } from '../types';
import styles from './AgentLevelBadge.module.css';

interface AgentLevelBadgeProps {
  level: AgentLevel;
  showLabel?: boolean;
  className?: string;
}

export function AgentLevelBadge({
  level,
  showLabel = true,
  className = '',
}: AgentLevelBadgeProps): JSX.Element {
  const { t } = useTranslation('training');
  const label = t(`agent.level.names.${level}`, { defaultValue: level });

  return (
    <span
      role="status"
      aria-label={label}
      data-level={level}
      className={`${styles.badge} ${styles[level] ?? ''} ${className}`.trim()}
    >
      {level}
      {showLabel && <span className={styles.label}>{label}</span>}
    </span>
  );
}
